<script>
import { MapAgentStationStatus, MapRefundStatus } from "@/common/util";
import PagenationContainer from "@/components/common/PagenationContainer.vue";

import cloneDeep from "lodash/cloneDeep";
import forOwn from "lodash/forOwn";
import moment from "moment";
export default {
  components: {
    PagenationContainer
  },
  data() {
    const ROLE_SUPER_ADMIN =
      localStorage.getItem("roles").indexOf("ROLE_SUPER_ADMIN") > -1;
    const ROLE_AGENT =
      localStorage.getItem("roles").indexOf("ROLE_AGENT") > -1 &&
      !(localStorage.getItem("roles").indexOf("ROLE_AGENT_OPTOMETRIST") > -1);
    const ROLE_REGION_MANAGER =
      localStorage.getItem("roles").indexOf("ROLE_REGION_MANAGER") > -1;
    const ROLE_AGENT_FINANCIAL =
      localStorage.getItem("roles").indexOf("ROLE_AGENT_FINANCIAL") > -1;
    return {
      ROLE_SUPER_ADMIN,
      ROLE_AGENT,
      ROLE_REGION_MANAGER,
      ROLE_AGENT_FINANCIAL,
      ProvinceList: [],
      searchFormData: {
        name: undefined,
        phone: undefined,
        agent: undefined,
        station: undefined,
        provinceCity: undefined
      },
      tableData: [],
      adminSearchArray: [
        {
          label: "患者姓名",
          keyName: "name",
          type: "text"
        },
        {
          label: "患者手机号",
          keyName: "phone",
          type: "text"
        },
        // {
        //   label: "代理商",
        //   keyName: "agentName",
        //   type: "text"
        // },
        {
          label: "代理商",
          keyName: "companyName",
          type: "text"
        },
        {
          label: "所属医疗机构",
          keyName: "stationName",
          type: "text"
        },
        {
          label: "省市搜索",
          keyName: "provinceCity",
          children: [],
          type: "cascader"
        }
      ],
      agentSearchArray: [
        {
          label: "患者姓名",
          keyName: "name",
          type: "text"
        },
        {
          label: "患者手机号",
          keyName: "phone",
          type: "text"
        },
        {
          label: "所属医疗机构",
          keyName: "stationId",
          type: "text"
        }
      ],
      regionSearchArray: [
        {
          label: "患者姓名",
          keyName: "name",
          type: "text"
        },
        {
          label: "患者手机号",
          keyName: "phone",
          type: "text"
        },
        {
          label: "状态",
          keyName: "refundState",
          type: "select",
          children: [
            {
              label: "全部",
              keyName: ""
            },
            {
              label: "患者审核",
              keyName: "PATIENT_REVIEW"
            },
            {
              label: "患者拒绝",
              keyName: "PATIENT_REFUSED"
            },
            {
              label: "大区经理审核",
              keyName: "REGION_REVIEW"
            },
            {
              label: "大区经理拒绝",
              keyName: "REGION_REFUSED"
            },
            {
              label: "已通过",
              keyName: "PASSED"
            }
          ]
        },
        {
          label: "代理商",
          keyName: "companyName",
          type: "text"
        },
        {
          label: "所属医疗机构",
          keyName: "stationName",
          type: "text"
        }
      ],
      refundPass: false,
      refundRject: false,
      defaultValue: {},
      agentList: [],
      pageCount: 0,
      activePage: 1,
      totalElements: 1
    };
  },
  computed: {
    activeSearchArray() {
      if (this.ROLE_AGENT || this.ROLE_AGENT_FINANCIAL) {
        return this.agentSearchArray;
      } else if (this.ROLE_REGION_MANAGER) {
        return this.regionSearchArray;
      } else if (this.ROLE_SUPER_ADMIN) {
        return this.adminSearchArray;
      }
    }
  },
  created() {
    this.loadProvice();
    this.loadData();
  },
  methods: {
    async loadData() {
      let params = {
        page: this.activePage - 1,
        sort: "createdAt,DESC",
        size: 10
      };
      for (let key in this.searchFormData) {
        if (key === "provinceCity") {
          if (this.searchFormData[key]) {
            if (this.searchFormData[key][0]) {
              params.provinceId = this.searchFormData[key][0];
            }
            if (this.searchFormData[key][1]) {
              params.districtId = this.searchFormData[key][1];
            }
          }
        } else if (this.searchFormData[key]) {
          params[key] = this.searchFormData[key];
        }
      }
      const data = await this.$http.GetRefundList(params);
      if (data && data.content) {
        console.log("___", data);
        let newTableData = [];
        this.pageCount = data.totalPages;
        this.totalElements = data.totalElements;
        data.content.forEach(item => {
          const temp = cloneDeep(item);
          temp.refundAt = moment(item.createdAt).format("YYYY-MM-DD HH:mm");
          temp.totalPrice = `${(
            parseFloat(item.courseCount) * parseFloat(item.unitPrice)
          ).toFixed(0)} 元`;
          temp.status = MapRefundStatus(item.refundState);
          newTableData.push(temp);
        });
        this.tableData = newTableData;
      }
    },
    onSearch(data) {
      this.activePage = 1;
      this.loadData();
    },
    async loadProvice() {
      let ProvinceList = [];
      let province = [];
      if (this.ROLE_SUPER_ADMIN) {
        ProvinceList = await this.$http.getProvinceList("superAdmin");
        province = this.adminSearchArray;
      }

      if (ProvinceList.length > 0) {
        const provinceChildren = ProvinceList.map(o => {
          return {
            label: o.name,
            keyName: o.id,
            value: o.id,
            children: o.sons.map(o => {
              return {
                label: o.name,
                value: o.id
              };
            }),
            id: o.id,
            name: o.name
          };
        });
        province.forEach(o => {
          if (o.keyName === "provinceCity") {
            o.children = provinceChildren;
          }
        });
        this.ProvinceList = provinceChildren;
      }
    },
    onSearchChange(data) {
      this.searchFormData = data;
    },
    onOperationClick(row, key) {
      this.defaultValue = row;
      switch (key) {
        case "PASSED":
          this.refundPass = true;
          break;
        case "REGION_REFUSED":
          this.refundRject = true;
          break;
      }
    },
    onClickCancel(key) {
      this.defaultValue = {};
      switch (key) {
        case "PASSED":
          this.refundPass = false;
          break;
        case "REGION_REFUSED":
          this.refundRject = false;
          break;
      }
    },
    async onUpdateRedfund(formdata, type, row) {
      const updateData = {
        historyId: row.id
      };
      if (type === "PASSED") {
        updateData.passed = true;
      } else if (type === "REGION_REFUSED") {
        updateData.passed = false;
      }
      let result = await this.$http.regionUpdateRedfund(updateData);
      this.loadData();
      this.defaultValue = {};
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.activePage = val;
      this.loadData();
    }
  }
};
</script>
<template>
  <div class="refundManagemmentIndex">
    <DialogForm
      v-if="refundPass"
      :defaultValue="defaultValue"
      formTitle="请确认通过退款"
      @close="onClickCancel"
      @submitForm="onUpdateRedfund"
      keyOperation="PASSED"
      confirmButton="确认"
    />
    <DialogForm
      v-if="refundRject"
      :defaultValue="defaultValue"
      formTitle="请确认拒绝退款"
      @close="onClickCancel"
      @submitForm="onUpdateRedfund"
      keyOperation="REGION_REFUSED"
      confirmButton="确认"
    />

    <searchFormNew
      class="searchForm"
      showSearch
      @onSearch="onSearch"
      @onChange="onSearchChange"
      :searchItemArray="activeSearchArray"
    />
    <div class="statistics">
      <i class="el-icon-info totalResult"></i>
      查询结果：
      <span class="totalResult">{{totalElements}}</span> 个
    </div>
    <el-table
      :data="tableData"
      class="refundTable"
      :header-cell-style="{ 'padding-left': '5px',color: 'rgba(0,0,0,0.65)','font-size': '14px', 'background-color': '#fafafa !important'}"
      :cell-style="{'padding-left': '5px'}"
    >
      <el-table-column prop="refundAt" align="left" label="退款时间" width="145"></el-table-column>
      <el-table-column prop="patientName" align="left" label="患者姓名" width="90"></el-table-column>
      <el-table-column prop="phone" align="left" label="患者手机号" width="120"></el-table-column>
      <el-table-column prop="courseCount" align="left" label="退货疗程" width="85"></el-table-column>
      <el-table-column prop="totalPrice" align="left" label="退款金额" width="85"></el-table-column>
      <el-table-column
        v-if="ROLE_REGION_MANAGER || ROLE_SUPER_ADMIN"
        prop="companyName"
        align="left"
        label="代理商"
        min-width="100"
      ></el-table-column>
      <el-table-column
        v-if="ROLE_AGENT || ROLE_AGENT_FINANCIAL"
        prop="operatorName"
        align="left"
        label="申请人"
        min-width="100"
      ></el-table-column>
      <el-table-column prop="stationName" align="left" label="所属医疗机构" min-width="120"></el-table-column>
      <el-table-column prop="remark" align="left" label="退款原因" min-width="175"></el-table-column>
      <el-table-column v-if="ROLE_REGION_MANAGER" prop="status" align="left" label="状态" width="145">
        <template slot-scope="scope">
          <el-button
            type="primary"
            v-if="scope.row.refundState === 'REGION_REVIEW'"
            size="mini"
            class="cellButtonGroup"
            @click="onOperationClick(scope.row, 'PASSED')"
          >授权</el-button>
          <el-button
            type="primary"
            class="cellButtonGroup"
            v-if="scope.row.refundState === 'REGION_REVIEW'"
            size="mini"
            @click="onOperationClick(scope.row, 'REGION_REFUSED')"
          >拒绝</el-button>
          <span v-if="!(scope.row.refundState === 'REGION_REVIEW')">{{scope.row.status}}</span>
        </template>
      </el-table-column>
    </el-table>
    <PagenationContainer v-if="pageCount > 1">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page="activePage"
        :page-count="pageCount"
        layout="prev, pager, next, jumper"
      ></el-pagination>
    </PagenationContainer>
  </div>
</template>

<style lang="scss">
@import "@/css/color.scss";

.refundManagemmentIndex {
  .searchForm {
    border: 1px;
    line-height: 50px;
    padding-top: 15px;
    width: 900px;
    margin: 0 1%;
    // float: left;
  }
  .statistics {
    float: right;
    margin-right: 30px;
    margin-top: -20px;
    margin-bottom: 5px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.45);
    line-height: 22px;
    .totalResult {
      color: #00c1de;
    }
  }
  .refundTable {
    margin: 10px 1%;
    border: 1px;
    width: 98%;

    .el-table__body tr:hover > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }

    .el-table__body tr.current-row > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }

    th > .cell {
      font-weight: bold;
    }

    .cellButtonGroup {
      background-color: #00c1de;
      border-color: #00c1de;
      margin-left: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/refundMangement/index.vue